import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import React, { useState, useEffect, useCallback } from 'react';
import EnhancedTableHead from '../../components/DataTables/TableHead';
import CustomizedTooltips from '../../components/CustomizedTooltips';
import TableToolbox from '../../components/TableToolbox';
import NewClient from './NewClient';
import useStyles from './styles';
import { useTheme } from '@mui/material/styles';
import { Strings } from '../../utils/strings';
import { useNavigate } from 'react-router-dom';
import {
  tableCell,
  secondaryTableCell,
  getErrorMessage,
  applySortFilter,
  getComparator,
  isAdmin,
} from '../../utils/appUtils';
import { connect } from 'react-redux';
import { fetchClientList } from '../../redux/actions/clientActions/clientList';
import { CircularProgress } from '@material-ui/core';
import CommonDialog from '../../components/CommonDialog';
import { deleteClient } from '../../redux/actions/clientActions/deleteClient';
import { deleteProperty } from '../../redux/actions/clientActions/deleteProperty';
import { icons } from '../../utils/icons';
import { Colors } from '../../utils/color';
import ClientFilter from './ClientFilter';
import { useAlert } from 'react-alert';
import { sendUserPassword } from '../../redux/actions/adminActions/sendUserPassword';
import debounce from 'lodash/debounce';
import { listFilter } from '../../redux/actions/filterActions/listFilter';
import NewClientFilter from './ClientFilter/NewClientFilter';

// ======== Table Head =========
const headCells = [
  { id: 'name', label: 'COMPANY/NAME', isSort: true },
  { id: 'properties', label: 'PROPERTY', isSort: true },
  { id: 'programType', label: 'PROGRAM TYPE', isSort: true },
  { id: 'email', label: 'EMAIL', isSort: true },
  { id: 'phone', label: 'PHONE' },
  { id: 'adminAssigned', label: 'ADMIN ASSIGNED', isSort: true },
  { id: '' },
];

const filterStore = 'ClientsFilter';

const Clients = (props) => {
  const classes = useStyles();
  const [search, setSearch] = useState('');
  const [newDialog, setNewDialog] = useState(false);
  const [openRows, setOpenRows] = useState([]);
  // const [clientListData, setClientListData] = useState([]);
  const clientListData = props.clientListData || [];
  const [deleteClientDialog, setDeleteClientDialog] = useState(false);
  const [deletePropertyDialog, setDeletePropertyDialog] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState({});
  const [selectedClient, setSelectedClient] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();
  const [clientFilterDialog, setClientFilterDialog] = useState(false);
  const [filter, setFilter] = useState(
    isAdmin() ? { showAllClient: false } : null
  );
  const alert = useAlert();
  const [sendPasswordUser, setSendPasswordUser] = useState('');
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');
  const [filterDropdownValue, setFilterDropdownValue] = useState('0');
  const [filterDropdownList, setFilterDropdownList] = useState([]);
  const [openEditFilterDialog, setOpenEditFilterDialog] = useState();
  const [isFilterChange, setIsFilterChange] = useState(false);

  const onError = (err) => {
    const error = getErrorMessage(err);
    if (error) {
      alert.error(error);
    }
  };

  const getClientList = (data) => {
    props.fetchClientList(data, (err) => onError(err));
  };

  const delayedSearch = useCallback(
    debounce((search, filter) => {
      if (Object.keys(filter)?.length > 0) {
        props?.fetchClientList({ searchString: search, filter }, (err) =>
          onError(err)
        );
      } else {
        props?.fetchClientList({ searchString: search }, (err) => onError(err));
      }
    }, 600),
    []
  );

  useEffect(() => {
    const storedFilter = localStorage.getItem(filterStore) || {};
    let prevFilter =
      Object.keys(storedFilter).length > 0 ? JSON.parse(storedFilter) : {};
    if (prevFilter?.filterId) {
      setFilterDropdownValue(prevFilter?.filterId || '0');
    }
    setFilter(prevFilter?.filter);
    const data = {
      searchString: search,
    };
    if (prevFilter) {
      data.filter = { ...prevFilter?.filter };
    } else if (filter) {
      data.filter = filter;
    }
    getClientList(data);
  }, [
    props.addClientData,
    props.deleteClientData,
    props.updateClientData,
    props.deletePropertyData,
  ]);

  // useEffect(() => {
  //   const data = props.clientListData ? props.clientListData : [];
  //   setClientListData(data);
  // }, [props.clientListData]);

  const onOpenRow = (rowIndex) => {
    if (openRows.findIndex((item, index) => item === rowIndex) === -1) {
      setOpenRows([...openRows, rowIndex]);
    } else {
      setOpenRows(openRows.filter((item) => item !== rowIndex));
    }
  };

  const onDeleteData = () => {
    if (deletePropertyDialog) {
      props.deleteProperty(
        selectedProperty._id,
        () => setDeletePropertyDialog(false),
        (err) => onError(err)
      );
    } else {
      props.deleteClient(
        selectedClient._id,
        () => setDeleteClientDialog(false),
        (err) => onError(err)
      );
    }
  };

  const setFilterData = (data) => {
    if (JSON.stringify(data) === '{}' && filter) {
      setSearch('');
      setFilter(isAdmin() ? { showAllClient: false } : null);
      getClientList({ searchString: '' });
      setFilterDropdownValue('0');
    } else if (JSON.stringify(data) !== '{}') {
      setSearch('');
      setFilter(data);
      getClientList({ filter: data });
      setFilterDropdownValue('0');
    }
    localStorage.setItem(filterStore, JSON.stringify({ filter: data }));
  };

  const handleSendPassword = (_id) => {
    setSendPasswordUser(_id);
    props.sendUserPassword(
      _id,
      () => {
        const data = {
          searchString: search,
        };
        setSendPasswordUser('');
        if (filter) data.filter = filter;
        getClientList(data);
      },
      (err) => {
        setSendPasswordUser('');
        onError(err);
      }
    );
  };

  const descendingComparator = (a, b, orderBy) => {
    let asceding = b[orderBy] < a[orderBy];
    let descding = b[orderBy] > a[orderBy];
    if (orderBy === 'name') {
      asceding = b[orderBy]?.toLowerCase() < a[orderBy]?.toLowerCase();
      descding = b[orderBy]?.toLowerCase() > a[orderBy]?.toLowerCase();
    } else if (orderBy === 'programType') {
      asceding =
        b[orderBy]?.title.toLowerCase() < a[orderBy]?.title.toLowerCase();
      descding =
        b[orderBy]?.title.toLowerCase() > a[orderBy]?.title.toLowerCase();
    }
    if (asceding) return -1;
    if (descding) return 1;
    return 0;
  };

  const onClickRefresh = () => {
    if (filterDropdownValue !== '0') {
      let filterData = filterDropdownList?.filter(
        (el) => el.value === filterDropdownValue
      )[0];
      getClientList(filterData?.filter ? { filter: filterData?.filter } : {});
    } else if (filter && Object.keys(filter).length > 0) {
      getClientList({ filter: filter });
    } else {
      getClientList({ searchString: search });
      setFilterDropdownValue('0');
    }
  };

  const onClickClearFilter = async () => {
    await setFilterDropdownValue('0');
    await setSearch('');
    if (isAdmin()) {
      await setFilter({ showAllClient: false });
      await getClientList({
        searchString: search,
        filter: { showAllClient: false },
      });
    } else {
      await setFilter(null);
      await getClientList({ searchString: search });
    }
    await localStorage.removeItem(filterStore);
  };

  const handleRequestSort = (event, property) => {
    setOpenRows([]);
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const filteredClients = applySortFilter(
    clientListData,
    getComparator(order, orderBy, descendingComparator)
  );

  useEffect(() => {
    !isFilterChange && props.listFilter('CLIENT_LIST', onError);
  }, []);

  useEffect(() => {
    if (isFilterChange) {
      const storedFilter = localStorage.getItem(filterStore) || {};
      let prevFilter =
        Object.keys(storedFilter).length > 0 ? JSON.parse(storedFilter) : {};
      if (prevFilter?.filterId) {
        localStorage.removeItem(filterStore);
      }
      props.listFilter('CLIENT_LIST', onError);
      filterDropdownValue !== '0' &&
        getClientList(
          isAdmin()
            ? { filter: { showAllClient: false } }
            : { searchString: '' }
        );
      if (isAdmin()) {
        setFilter({ showAllClient: false });
      } else {
        setFilter(null);
      }
      setFilterDropdownValue('0');
      setIsFilterChange(false);
    }
  }, [isFilterChange]);

  useEffect(() => {
    const data = props?.listFilterData?.map((el) => ({
      title: el?.filterName,
      value: el?._id,
      filter: el.filter,
    }));
    setFilterDropdownList(data || []);
  }, [props.listFilterData]);

  const handleFilterSelectionClick = async (value) => {
    let filterData = filterDropdownList?.filter((el) => el.value === value)[0];
    setFilter(filterData?.filter || {});
    localStorage.setItem(
      filterStore,
      JSON.stringify({
        filter: { ...filterData?.filter },
        filterId: value,
      })
    );
    await getClientList(
      filterData?.filter ? { filter: filterData?.filter } : {}
    );
  };

  return (
    <div className={classes.client_container}>
      <TableToolbox
        isSearch
        search={search}
        isFilter
        onChangeSearch={(e) => {
          const newFilter = isAdmin() ? { showAllClient: false } : {};
          delayedSearch(e.target.value, newFilter);
          setFilter(isAdmin() ? { showAllClient: false } : null);
          setSearch(e.target.value);
          setFilterDropdownValue('0');
          // getClientList({ searchString: e.target.value });
        }}
        onNewClick={() => setNewDialog(true)}
        isPrimaryButton
        isSecondaryButton
        secondaryButtonText={Strings.PROGRAM_TYPE + 's'}
        secondaryButtonClick={() => navigate('/app/clients/programs')}
        filterButtonClick={() => setClientFilterDialog(true)}
        isFilterDropdown={filterDropdownList.length ? true : false}
        filterDropdownValue={filterDropdownValue}
        filterDropdownList={filterDropdownList}
        onChangeFilterDropdown={async (e) => {
          await setFilterDropdownValue(e.target.value);
          await handleFilterSelectionClick(e.target.value);
        }}
        onEditClick={(value) =>
          setOpenEditFilterDialog({ show: true, ...value })
        }
        onClickRefresh={onClickRefresh}
        onClickClearFilter={onClickClearFilter}
      />
      <div className={classes.list_container}>
        {props.clientListLoading ? (
          <div className={classes.flexView}>
            <CircularProgress
              style={{
                color: theme.palette.background_button,
              }}
            />
          </div>
        ) : (
          <>
            {clientListData.length === 0 ? (
              <div className={classes.flexView}>
                <p className={classes.no_data_message}>
                  {Strings.NO_DATA_FOUND}
                </p>
              </div>
            ) : (
              <TableContainer>
                <Table sx={{ minWidth: 930 }} aria-labelledby='tableTitle'>
                  <EnhancedTableHead
                    headCells={headCells}
                    handleRequestSort={handleRequestSort}
                    order={order}
                    orderBy={orderBy}
                  />
                  <TableBody>
                    {clientListData &&
                      filteredClients?.map((data, index) => {
                        const {
                          name,
                          properties,
                          programType,
                          email,
                          phoneNumber,
                          adminAssigned,
                          issues,
                          _id,
                          countryCode,
                          // passwordSent,
                        } = data;
                        return (
                          <>
                            <TableRow
                              key={data._id}
                              sx={{ width: '100%' }}
                              onClick={() => onOpenRow(index)}
                            >
                              <TableCell
                                style={{
                                  ...tableCell(
                                    theme,
                                    openRows.findIndex(
                                      (item) => item === index
                                    ) !== -1
                                  ),
                                }}
                                component='td'
                                scope='row'
                              >
                                <Stack
                                  paddingTop={2.5}
                                  direction='row'
                                  alignItems='center'
                                >
                                  <img
                                    className={classes.toggle_arrow}
                                    src={
                                      openRows.findIndex(
                                        (item) => item === index
                                      ) !== -1
                                        ? icons(theme).downArrow
                                        : icons(theme).rightArrow
                                    }
                                    alt=''
                                    // onClick={() => onOpenRow(index)}
                                  />
                                  <label className={classes.name_cell}>
                                    {name}
                                  </label>
                                </Stack>
                              </TableCell>
                              <TableCell
                                style={{
                                  ...tableCell(
                                    theme,
                                    openRows.findIndex(
                                      (item) => item === index
                                    ) !== -1
                                  ),
                                }}
                                component='td'
                                scope='row'
                              >
                                <Stack
                                  paddingTop={2.5}
                                  direction='row'
                                  alignItems='center'
                                >
                                  <label className={classes.common_cell}>
                                    {properties?.length || 0}
                                  </label>
                                  <div
                                    style={{
                                      backgroundColor: issues
                                        ? Colors.TOMATO_RED
                                        : Colors.LIGHT_GREEN,
                                    }}
                                    className={classes.issue_container}
                                  >
                                    {`${issues || 0} issues`}
                                  </div>
                                </Stack>
                              </TableCell>
                              <TableCell
                                style={{
                                  ...tableCell(
                                    theme,
                                    openRows.findIndex(
                                      (item) => item === index
                                    ) !== -1
                                  ),
                                }}
                                component='td'
                                scope='row'
                              >
                                <Stack
                                  paddingTop={2.5}
                                  direction='column'
                                  alignItems='flex-start'
                                >
                                  <label className={classes.common_cell}>
                                    {programType.title}
                                  </label>
                                </Stack>
                              </TableCell>
                              <TableCell
                                style={{
                                  ...tableCell(
                                    theme,
                                    openRows.findIndex(
                                      (item) => item === index
                                    ) !== -1
                                  ),
                                }}
                                component='td'
                                scope='row'
                              >
                                <Stack
                                  paddingTop={2.5}
                                  direction='column'
                                  alignItems='flex-start'
                                >
                                  <label className={classes.common_cell}>
                                    {email}
                                  </label>
                                </Stack>
                              </TableCell>
                              <TableCell
                                style={{
                                  ...tableCell(
                                    theme,
                                    openRows.findIndex(
                                      (item) => item === index
                                    ) !== -1
                                  ),
                                }}
                                component='td'
                                scope='row'
                              >
                                <Stack
                                  paddingTop={2.5}
                                  direction='column'
                                  alignItems='flex-start'
                                >
                                  <label className={classes.common_cell}>
                                    {countryCode + phoneNumber}
                                  </label>
                                </Stack>
                              </TableCell>
                              <TableCell
                                style={{
                                  ...tableCell(
                                    theme,
                                    openRows.findIndex(
                                      (item) => item === index
                                    ) !== -1
                                  ),
                                }}
                                component='td'
                                scope='row'
                              >
                                <Stack
                                  paddingTop={2.5}
                                  direction='column'
                                  alignItems='flex-start'
                                >
                                  <label className={classes.common_cell}>
                                    {adminAssigned}
                                  </label>
                                </Stack>
                              </TableCell>
                              <TableCell
                                style={{
                                  ...tableCell(
                                    theme,
                                    openRows.findIndex(
                                      (item) => item === index
                                    ) !== -1
                                  ),
                                }}
                                component='td'
                                scope='row'
                                align='right'
                              >
                                <Stack
                                  paddingTop={2.5}
                                  direction='row'
                                  alignItems='center'
                                  justifyContent='end'
                                >
                                  {/* {!passwordSent && (
                                  <>
                                    {sendPasswordUser === _id ? (
                                      <CircularProgress
                                        size={24}
                                        style={{
                                          color:
                                            theme.palette.background_button,
                                          marginRight: 15,
                                        }}
                                      />
                                    ) : (
                                      <CustomizedTooltips
                                        title={Strings.SEND_PASSWORD}
                                      >
                                        <img
                                          className={classes.action_icons}
                                          style={{ marginRight: 15 }}
                                          src={icons(theme).reportSendIcon}
                                          alt=''
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleSendPassword(_id);
                                          }}
                                        />
                                      </CustomizedTooltips>
                                    )}
                                  </>
                                )} */}
                                  <CustomizedTooltips
                                    title={Strings.ADD_PROPERTY}
                                  >
                                    <img
                                      className={classes.action_icons}
                                      style={{ marginRight: 15 }}
                                      src={icons(theme).addIcon}
                                      alt=''
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        navigate('/app/clients/add/property', {
                                          state: {
                                            _id,
                                            name,
                                            programType,
                                          },
                                        });
                                      }}
                                    />
                                  </CustomizedTooltips>
                                  <CustomizedTooltips
                                    title={Strings.EDIT_CLIENT}
                                  >
                                    <img
                                      className={classes.action_icons}
                                      src={icons(theme).editIcon}
                                      style={{ marginRight: 15 }}
                                      alt=''
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setIsEdit(true);
                                        setSelectedClient(data);
                                        setNewDialog(true);
                                      }}
                                    />
                                  </CustomizedTooltips>
                                  <CustomizedTooltips
                                    title={Strings.DELETECLIENT}
                                  >
                                    <img
                                      className={classes.action_icons}
                                      src={icons(theme).deleteIcon}
                                      alt=''
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setSelectedClient(data);
                                        setDeleteClientDialog(true);
                                      }}
                                    />
                                  </CustomizedTooltips>
                                </Stack>
                              </TableCell>
                            </TableRow>
                            {openRows.findIndex((item) => item === index) !==
                              -1 &&
                              properties &&
                              properties.map((item, index) => {
                                const { name, address } = item;
                                return (
                                  <TableRow
                                    key={item._id}
                                    sx={{ width: '100%' }}
                                    onClick={() =>
                                      navigate('/app/clients/view/property', {
                                        state: {
                                          programType,
                                          properties,
                                          selectedProperty: item._id,
                                        },
                                      })
                                    }
                                  >
                                    <TableCell
                                      style={{
                                        ...secondaryTableCell(
                                          theme,
                                          index + 1 === properties.length
                                        ),
                                        cursor: 'pointer',
                                      }}
                                      component='td'
                                      scope='row'
                                      // onClick={() =>
                                      //   navigate('/app/clients/view/property', {
                                      //     state: {
                                      //       programType,
                                      //       properties,
                                      //       selectedProperty: item._id,
                                      //     },
                                      //   })
                                      // }
                                    >
                                      <Stack
                                        direction='row'
                                        alignItems='center'
                                      >
                                        <label
                                          style={{
                                            marginLeft: 39,
                                            cursor: 'pointer',
                                          }}
                                          className={classes.name_cell}
                                        >
                                          {name}
                                        </label>
                                      </Stack>
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        ...secondaryTableCell(
                                          theme,
                                          index + 1 === properties.length
                                        ),
                                        cursor: 'pointer',
                                      }}
                                      component='td'
                                      scope='row'
                                      colSpan={5}
                                      // onClick={() =>
                                      //   navigate('/app/clients/view/property', {
                                      //     state: {
                                      //       programType,
                                      //       properties,
                                      //       selectedProperty: item._id,
                                      //     },
                                      //   })
                                      // }
                                    >
                                      <Stack
                                        direction='row'
                                        alignItems='flex-start'
                                      >
                                        <label
                                          style={{
                                            cursor: 'pointer',
                                          }}
                                          className={classes.common_cell}
                                        >
                                          {address}
                                        </label>
                                      </Stack>
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        ...secondaryTableCell(
                                          theme,
                                          index + 1 === properties.length
                                        ),
                                      }}
                                      component='td'
                                      scope='row'
                                      align='right'
                                    >
                                      <Stack
                                        direction='row'
                                        alignItems='center'
                                        justifyContent='end'
                                      >
                                        <CustomizedTooltips
                                          title={Strings.DELETEPROPERTY}
                                        >
                                          <img
                                            className={classes.action_icons}
                                            src={icons(theme).deleteIcon}
                                            alt=''
                                            onClick={(e) => {
                                              e.preventDefault();
                                              e.stopPropagation();
                                              setSelectedProperty(item);
                                              setDeletePropertyDialog(true);
                                            }}
                                          />
                                        </CustomizedTooltips>
                                      </Stack>
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                          </>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </>
        )}
      </div>
      {newDialog && (
        <NewClient
          data={selectedClient}
          isEdit={isEdit}
          onNewClose={() => {
            setIsEdit(false);
            setNewDialog(false);
          }}
        />
      )}
      {(deleteClientDialog || deletePropertyDialog) && (
        <CommonDialog
          title={Strings.CLIENT}
          message={
            deletePropertyDialog
              ? Strings.DELETE_PROPERTY
              : Strings.DELETE_CLIENT
          }
          onSuccess={() => onDeleteData()}
          onClose={() => {
            if (deletePropertyDialog) setDeletePropertyDialog(false);
            else setDeleteClientDialog(false);
          }}
          loading={
            deletePropertyDialog
              ? props.deletePropertyLoading
              : props.deleteClientLoading
          }
        />
      )}
      {clientFilterDialog && (
        <ClientFilter
          setFilterData={setFilterData}
          filterData={filter}
          setIsFilterChange={setIsFilterChange}
          onClose={() => setClientFilterDialog(false)}
        />
      )}
      {openEditFilterDialog?.show && (
        <NewClientFilter
          isEdit={true}
          selectedId={openEditFilterDialog?.value}
          setIsFilterChange={setIsFilterChange}
          onClose={() => setOpenEditFilterDialog()}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  addClientData: state.addClientData.data,
  clientListData: state.clientListData.data,
  clientListLoading: state.clientListData.loading,

  updateClientData: state.updateClientData.data,

  deleteClientData: state.deleteClientData.data,
  deleteClientLoading: state.deleteClientData.loading,

  deletePropertyData: state.deletePropertyData.data,
  deletePropertyLoading: state.deletePropertyData.loading,

  sendUserPasswordData: state.sendUserPasswordData.data,
  sendUserPasswordLoading: state.sendUserPasswordData.loading,

  listFilterData: state.listFilterData.data,
  listFilterLoading: state.listFilterData.loading,

  addFilterData: state.addFilterData.data,
  updateFilterData: state.updateFilterData.data,
  deleteFilterData: state.deleteFilterData.data,
});

export default connect(mapStateToProps, {
  fetchClientList,
  deleteClient,
  deleteProperty,
  sendUserPassword,
  listFilter,
})(Clients);
